// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"077d2591","186":"43b78093","243":"c5e5d729","582":"a0349aa3","722":"d7f9e30b","882":"baca4eff"}[chunkId] + ".chunk.js";
};